import { Injectable } from '@angular/core';
import { SimpleChanges } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PdfViewerControlService {
  private pdfViewerComponent: any = null;
  private originalNgOnChanges: ((changes: SimpleChanges) => any) | null = null;

  registerPdfViewer(component: any, originalNgOnChanges: (changes: SimpleChanges) => any) {
    this.pdfViewerComponent = component;
    this.originalNgOnChanges = originalNgOnChanges;
  }

  unregisterPdfViewer() {
    this.pdfViewerComponent = null;
    this.originalNgOnChanges = null;
  }

  pausePdfViewer() {
    if (this.pdfViewerComponent && this.originalNgOnChanges && false) {
      // Replace ngOnChanges with a no-op function
      this.pdfViewerComponent.ngOnChanges = () => {};
    }
  }

  resumePdfViewer() {
    if (this.pdfViewerComponent && this.originalNgOnChanges && false) {
      // Restore the original ngOnChanges function
      this.pdfViewerComponent.ngOnChanges = this.originalNgOnChanges;
    }
  }
}
